import React from 'react';
import { View, Text, StyleSheet } from 'react-native';

// React.memo prevents the item from re-rendering unless its props change.
// Since 'now' changes every second, it will re-render, but it prevents 
// re-renders from other unrelated parent state changes.
const PaymentCountdownItem = React.memo(({ due, now }) => {
  if( due === null ) {
    return <></>;
  }

  // Calculate remaining time in seconds, bottoming out at 0
  const timeRemaining = Math.max(0, Math.floor((due - now) / 1000));

  // Format the time into Hours, Minutes, Seconds
  const hours = Math.floor(timeRemaining / 3600);
  const minutes = Math.floor((timeRemaining % 3600) / 60);
  const seconds = timeRemaining % 60;

  const isExpired = timeRemaining <= 0;

  return (
    <Text style={[styles.expiry, isExpired && styles.expired]}>
      {
        isExpired 
        ? 'Dibatalkan otomatis: pembayaran expired' 
        : `Selesaikan pembayaran dalam: ${hours.toString().padStart(2,`0`)}:${minutes.toString().padStart(2,`0`)}:${seconds.toString().padStart(2,`0`)}`
      }
    </Text>
  );
});

export default PaymentCountdownItem;

const styles = StyleSheet.create({
  expiry: {
    textWrap: "nowrap",
    fontFamily: 'Poppins',
    fontSize: 11,
    color: '#D97706',
    lineHeight: 16,
  },
  expired: {
    textWrap: "wrap",
    color: '#EF4444',
  }
});